import { type FC, Suspense } from 'react'

import { lazyIcons } from '@redteclab/brand-icons/lazy'

import { BrandIcon } from 'base-ui'

import { type StoryblokServicesListItemType } from '../../storyblok'

export const StoryblokListButtonBrandIcon: FC<{
  icon: StoryblokServicesListItemType['icon']
}> = ({ icon }) => {
  if (typeof icon !== 'string') {
    return null
  }

  const SvgIcon = Object.entries(lazyIcons).find(([key]) => key === icon)?.[1]

  if (!SvgIcon) {
    return null
  }

  return (
    <Suspense>
      <BrandIcon className="ml-4 shrink-0" icon={SvgIcon} size="s" />
    </Suspense>
  )
}
